import { render, staticRenderFns } from "./Giftee.vue?vue&type=template&id=333d7c23&"
import script from "./Giftee.vue?vue&type=script&lang=js&"
export * from "./Giftee.vue?vue&type=script&lang=js&"
import style0 from "./Giftee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports